import { atom } from 'recoil';
export const uploadFromCsvStudentState = atom({
    key: 'uploadFromCsvStudentState',
    default: {
        processCompleted: false,
        recordsInserted: 0,
        recordsFailed: 0,
        isLoading: false,
        isFormInvalid: true,
        openMainModal: false,
        modalEditStudent: false,
        mainError: '',
        dirtyFields: {},
        step: 0,
        step0Ready: false,
        step1Ready: false,
        step2Ready: false,
        modalClose: false,
        invalidFile: false,
        modalMessageDelete: false,
        modalMessageSave: false,
        modalExceededStudents: false,
        modalConfirmChanges: false,
        fieldMap: {
            firstMapping: false,
            firstNameColumnMatched: '',
            lastNameColumnMatched: '',
            emailColumnMatched: '',
            classGradeColumnMatched: ''
        },
        firstNameTableValidation: '',
        lastNameTableValidation: '',
        emailTableValidation: '',
        classGradeTableValidation: '',
        listMapped: [],
        issuesFound: 0,
        studentsToInvite: 0,
        duplicates: 0,
        fileParsedResult: {
            data: [],
            errors: [],
            meta: {},
            fileName: 'StudentTemplate.csv'
        },
        mainTitle: 'Add students from CSV',
        finalTextButton: 'Confirm',
        isSmallGroup: false
    }
});
export const modalEditState = atom({
    key: 'modalEditState_studentComponent',
    default: {
        isLoading: false,
        isFormInvalid: false,
        mainError: '',
        dirtyFields: { firstName: false, lastName: false, email: false },
        firstName: '',
        lastName: '',
        email: '',
        firstNameError: '',
        lastNameError: '',
        emailError: '',
        title: null,
        classGrade: '',
        grades: {}
    }
});
